<template>
  <!-- 生产提示 -->
  <div class="hint">
    <el-form style="margin-bottom: 0.8rem;" label-width="8rem">
      <el-form-item label="行为监控数据">
          <el-select v-model="set.getType" placeholder="请选择">
              <el-option label="手动录入" :value="0"></el-option>
              <el-option label="后台获取" :value="1"></el-option>
            </el-select>
      </el-form-item>
    </el-form>
    <table class="mytable" style="width:80%">
      <thead>
        <tr>
          <th style="width:15rem">提示时间</th><th style="width:8rem">事件类型</th><th style="width:15rem">发生区域</th><th>事件主题</th><th>事件内容</th>
          <th>
            <i @click="addRow" style="font-size: 1.2rem;font-weight: 600;cursor:pointer;position: relative;top: 0.1rem;color: #00ffff;" class="el-icon-circle-plus-outline"></i>
          </th>
        </tr>
      </thead>
      <tbody>
 
        <tr v-for="(item,i) in tableData" :key='i'>
          <td>
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss"  v-model="item.noteTime" type="datetime" placeholder="选择日期时间"> </el-date-picker>
          </td>
          <td>
            <el-select v-model="item.eventType" placeholder="请选择">
              <el-option label="安全提示" :value="0"></el-option>
              <el-option label="管理提示" :value="1"></el-option>
              <el-option label="能耗突增" :value="2"></el-option>
              <el-option label="能耗超标" :value="3"></el-option>
            </el-select>
          </td>
          <td>
            <el-input v-model="item.eventArea" placeholder="请录入"></el-input>
          </td>
          <td>
            <el-input v-model="item.eventBody" placeholder="请录入"></el-input>
          </td>
          <td>
            <el-input v-model="item.eventContent" placeholder="请录入"></el-input>
          </td>

          <td style="width: 6rem; text-align:center">
            <i @click="del(item, i)" class="el-icon-remove-outline" style="font-size: 1.2rem;line-height: 1.8rem;color: #f00;font-weight: 600;cursor: pointer;"></i>
          </td>
        </tr>

      </tbody>
    </table>
    <p v-if="!tableData.length" style="text-align: center;margin-top: 5rem;">暂无数据</p>
    <!-- <el-form style="margin-bottom: 0.8rem;" label-width="8rem">
      <el-form-item label="行为监控数据">
        <el-row :gutter="0">
          <el-col :span="6">
            <el-select v-model="set.getType" placeholder="请选择">
              <el-option label="手动录入" :value="0"></el-option>
              <el-option label="后台获取" :value="1"></el-option>
            </el-select>
          </el-col>

          <el-col :span="2">
            <el-button @click="addRow" size="small" type="success">添加数据</el-button>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <el-form  style="margin-bottom: 0.8rem;"  v-for="(item,i) in tableData" :key="i"  class="bginput" label-width="7rem">
      <i class="el-icon-remove-outline"></i>
      <el-form-item label="提示时间">
        <el-date-picker v-model="item.noteTime" type="datetime" placeholder="选择日期时间"> </el-date-picker>
      </el-form-item>
      <el-form-item label="事件类型">
        <el-select v-model="item.eventType" placeholder="请选择">
              <el-option label="安全提示" :value="0"></el-option>
              <el-option label="管理提示" :value="1"></el-option>
              <el-option label="能耗突增" :value="2"></el-option>
              <el-option label="能耗超标" :value="3"></el-option>
            </el-select>
      </el-form-item>
      <el-form-item label="发生区域">
        <el-input v-model="item.eventArea" placeholder="请录入"></el-input>
      </el-form-item>
      <el-form-item label="事件主体">
        <el-input v-model="item.eventBody" placeholder="请录入"></el-input>
      </el-form-item>
      <el-form-item label="事件内容">
        <el-input v-model="item.eventContent" placeholder="请录入"></el-input>
      </el-form-item>


    </el-form> -->
    <div style="margin-top: 2rem">
      <el-button @click="save" size="small" type="primary save">保存设置</el-button>
    </div>


  </div>
</template>

<script>
import api from '@/apis/produce/hint'
export default {
  data() {
    return {
      value1: '',
      set: { getType: 0 },
      tableData: [],
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {

    getlist(){
        api
      .list({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
  
            this.tableData = res.data.list
          
        } else {
          this.$message.error(res.message)
        }
      })      
    },    
    addRow() {
      this.tableData.unshift({
        noteTime: '',//提示时间
        eventArea: '',//发生区域
        eventBody: '',//事件主体
        eventContent: '', //事件内容
        eventType: 0, //事件类型
      })
    },    
    del(item, i) {
      this.$confirm(`确定删除数据？`).then(() => {
        if (item.id) {
          
          api.del([item.id]).then((res) => {
            if (res.code === 10000) {
              this.getlist()
              this.$message.success(res.message)
              this.tableData.splice(i, 1)
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          this.tableData.splice(i, 1)
        }
      })
    },

    save() {
      api.save(this.tableData).then((res) => {
        if (res.code === 10000) {
          this.getlist()
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },    
  },
}
</script>

<style lang="less">
.hint { padding-top: 10px;
  .mytable{
    .el-input{ width: 100%;}
  }
  // .bginput{ display:inline-block; border: #3570ff solid 1px; position: relative; width: 45%; padding:1rem; margin-right:1rem; margin-bottom: 1rem; position: relative;
  //   .el-icon-remove-outline{font-size: 1rem;line-height: 1.8rem;color: #f00;font-weight: 600;margin-left: 1rem;cursor: pointer; position: absolute; top: .5rem; right: 1rem;}
  //   .el-form-item {
  //     margin-bottom: 0; display: inline-block; width: 45%;
  //     .el-date-editor{ width: 100%;}
  //   }
  // }
  
}
</style>